// Fonction pour obtenir une image aléatoire parmi img1.png à img5.png
export const getRandomFallbackImage = () => {
  const randomNum = Math.floor(Math.random() * 11) + 1; // Génère un nombre entre 1 et 11
  return `/images/img${randomNum}.png`;
};
